import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../components/ReactSelect';
import { bin2hex, dataMysql, extract, pontoVirgula } from '../../../util/util';
import { toast } from 'react-toastify';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Button } from 'react-bootstrap';

export default function CadastroEventoCarta({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [tabState, setTabState] = useState("geral");
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({ codigoFonte: false });
    const [carta, setCarta] = useState("");
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/eventoCarta/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: [
                        'cliente',
                    ]
                });
                setDados(dadosRecebidos);
                setCarta(dadosRecebidos.carta);
            }).catch(err => {
                //console.log(err)
            });
        }//if id
        else {
            setDados({ ...dados });
        }
    };

    const validar = () => {
        var tipo = document.querySelector("#tipo");
        if (dados.tipo === undefined || dados.tipo === '') {
            toast.error('É necessário preencher o tipo da carta');
            setTimeout(() => {
                tipo.focus();
            }, 500);
            return false;
        }
        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false; //para codigo aqui
        }

        if (id) {//update
            api({
                method: 'put',
                action: '/eventoCarta/' + id,
                token: token,
                data: {
                    ...dados,
                    ...{ carta: bin2hex(dados.carta) },
                }
            })
                .then(function (response) {
                    //console.log(response.data);
                    //history.push("/eventoCarta");
                    toast.success("As alterações foram salvas com sucesso!");
                })
                .catch(function (error) {
                    toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
                });
        } else {//insert
            api({
                method: 'post',
                action: '/eventoCarta',
                token: token,
                data: {
                    ...dados,
                    ...{ carta: bin2hex(dados.carta) },
                }
            })
                .then(function (response) {
                    //console.log(response.data);
                    history.push("/eventoCarta");
                })
                .catch(function (error) {
                    toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
                });
        }
    };

    useEffect(() => { //onload
        //document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>Modelo de Carta</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Tipo da Carta</label>
                                                        <ReactSelect
                                                            id="tipo"
                                                            value={{ value: dados.tipo, label: dados.nomeTipo }}
                                                            onChange={e => setDados({ ...dados, ...{ "tipo": e.value, "nomeTipo": e.label } })}
                                                            options={[
                                                                { value: 'emailconvite', label: 'E-mail Convite' },
                                                                { value: 'emailinformativa', label: 'E-mail Informativa' },
                                                                { value: 'contrato', label: 'Contrato' },
                                                                { value: 'convite', label: 'Convite' },
                                                                { value: 'informativa', label: 'Informativa' },
                                                                { value: 'termoaceite', label: 'Termo de Aceite' },
                                                                { value: 'certificado', label: 'Certificado' },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            id="cliente"
                                                            value={{ value: dados.cliente, label: dados.nomeCliente }}
                                                            onChange={e => setDados({ ...dados, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipoCadastro: "cliente",
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Tipo do Evento</label>
                                                        <ReactSelect
                                                            value={{ value: dados.eventoTipo, label: dados.nomeEventoTipo }}
                                                            onChange={e => setDados({ ...dados, ...{ "eventoTipo": e.value, "nomeEventoTipo": e.label } })}
                                                            options={[
                                                                { value: 'advisoryboard', label: 'Advisory Board' },
                                                                { value: 'congresso', label: 'Congresso' },
                                                                { value: 'congressonacional', label: 'Congresso Nacional' },
                                                                { value: 'congressointernacional', label: 'Congresso Internacional' },
                                                                { value: 'congestadcotapat', label: 'Congresso - Estande e/ou Cota de Patrocínio' },
                                                                { value: 'convencaonacional', label: 'Convenção Nacional' },
                                                                { value: 'convencaointernacional', label: 'Convenção Internacional' },
                                                                { value: 'estandecotapat', label: 'Estande e/ou Cota de Patrocínio' },
                                                                { value: 'estcotpatsimpsanoeveterc', label: 'Estande e/ou Cota de Patrocínio - Simpósio Sanofi em Evento de Terceiro' },
                                                                { value: 'estcotpatcongsimpsanoeveterc', label: 'Estande e/ou Cota de Patrocínio - Congresso - Simpósio Sanofi em Evento de Terceiro' },
                                                                { value: 'eventoexclusivo', label: 'Evento Exclusivo' },
                                                                { value: 'eventointerno', label: 'Evento Interno' },
                                                                { value: 'minimeet', label: 'Mini Meeting' },
                                                                { value: 'orgsede', label: 'Organizado Pela Sede' },
                                                                { value: 'reuniaotreinamento', label: 'Reunião de Treinamento' },
                                                                { value: 'scieneducpromee', label: 'Scientific Educational Program/Meeting' },
                                                                { value: 'simposio', label: 'Simpósio' },
                                                                { value: 'simpsanofeventerc', label: 'Simpósio Sanofi em Evento de Terceiro' },
                                                                { value: 'speakmeet', label: 'Speaker Meeting (One-Time)' },
                                                                { value: 'webmeeting', label: 'Web Meeting' },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Formato do Evento</label>
                                                        <ReactSelect
                                                            value={{ value: dados.eventoTipoRealizacao, label: dados.nomeEventoTipoRealizacao }}
                                                            onChange={e => setDados({ ...dados, ...{ "eventoTipoRealizacao": e.value, "nomeEventoTipoRealizacao": e.label } })}
                                                            options={[
                                                                { value: 'digital', label: 'Digital' },
                                                                { value: 'presencial', label: 'Presencial' },
                                                                { value: 'hibrido', label: 'Híbrido' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <label>Nacionalidade do Evento</label>
                                                        <ReactSelect
                                                            id="nacionalidade"
                                                            value={{ value: dados.eventoNacionalidade, label: dados.nomeEventoNacionalidade }}
                                                            onChange={e => setDados({ ...dados, ...{ "eventoNacionalidade": e.value, "nomeEventoNacionalidade": e.label } })}
                                                            options={[
                                                                { value: 'nacional', label: 'Nacional' },
                                                                { value: 'internacional', label: 'Internacional' }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Nome da carta"
                                                            value={dados.nome}
                                                            onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome da Carta</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ position: 'relative' }}>
                                                <Button
                                                    style={{ position: 'absolute', top: '-5px', right: '10px', width: '150px' }}
                                                    className="btn btn-sm btn-primary me-1 mb-1"
                                                    onClick={() => {
                                                        dados.codigoFonte = !dados.codigoFonte;
                                                        setDados({ ...dados });
                                                    }}>
                                                    Código Fonte
                                                </Button>
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Carta</label>
                                                        {!dados.codigoFonte ?
                                                            <>
                                                                <div id="barraFerramentas"></div>
                                                                <CKEditor
                                                                    data={carta}
                                                                    editor={Editor}
                                                                    onReady={editor => {
                                                                        const toolbarContainer = document.querySelector('#barraFerramentas');
                                                                        toolbarContainer.appendChild(editor.ui.view.toolbar.element);
                                                                    }}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        setDados({ ...dados, ...{ "carta": data } });
                                                                        setCarta(data);
                                                                    }}
                                                                />
                                                            </>
                                                            :
                                                            <textarea
                                                                className="form-control form-control-lg"
                                                                id="carta"
                                                                style={{ minHeight: "500px" }}
                                                                value={carta}
                                                                onChange={(e) => {
                                                                    var novaCarta = e.target.value;
                                                                    setDados({ ...dados, ...{ "carta": novaCarta } });
                                                                    setCarta(novaCarta);
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row fixoRodape">
                                                <div className="col-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSave size={20} /> Salvar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}